import React, { useState } from 'react'
import QuoteImage from "../assets/QuoteBannerImage.jpg"
import BannerImage from "../assets/BannerImage.jpg";
import {toast} from 'react-toastify';
import { useNavigate } from 'react-router-dom';

    // https://api.deepai.org/job-view-file/8aee9826-5664-4c30-ba7c-574397a11fea/outputs/output.jpg

const Quote = () => {

    const [user, setUser] = useState({name: "", email:"", phone:"", Address:"", car_rego:"", car_purpose:"", insurance_s_d:""});
    const history = useNavigate();

    let name, value;
    const handleInput = (e) =>{
        name = e.target.name;
        value = e.target.value;
    
        setUser({...user,[name]:value});
    }


    const QuoteSubmit = async(e) =>{
        e.preventDefault();
    const { name, email, phone, Address, car_rego, car_purpose, insurance_s_d} = user;
    if(name ==='' || email===''|| phone===''|| Address === '' || car_rego==='' || car_purpose === '' || insurance_s_d === ''){
       return toast.warning('Please fill the form properly....')
    }

        const res = await fetch('https://ozwidecover-backend.vercel.app/api/quote', {
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({name:name, email:email, phone:phone, Address:Address, car_rego:car_rego, car_purpose: car_purpose, insurance_s_d: insurance_s_d})
        })

        const data = await res.json();

        if(res.status === 422 || !data){
            toast.error('Invalid Details...')
        }
        else{
            toast.success('Quote Received Successfully...')
            history('/');
        }
}
  return (
    <div >

<div className='relative -z-50'>
            <div className="absolute w-full h-[300px]">
                <img src={BannerImage} alt="getaquote" className="object-cover w-full h-[300px] opacity-95" />
            </div>
            <div className="relative flex  bg-gray-800 opacity-55">
                <div className="flex justify-start mx-12 items-center leading-8 w-full h-[300px]">
                    <h1 className=" font-bold text-5xl md:text-5xl text-white">Get a Quote</h1>
                     {/* <span><Link className='text-white' to='/'>Home</Link></span>  */}
                </div>
            </div>
        </div>
        
        <div className="relative w-full min-h-[325px] bg-cover bg-center flex items-center justify-center " style={{backgroundImage: `URL(${QuoteImage})`}} >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative text-white px-4 md:px-8 ">
        <div className="border rounded-lg px-4 py-6 m-auto my-8 ">
        <h2 className="text-5xl font-bold text-center mb-4">Get a Quote</h2>
        <form className='w-[350px] md:w-[720px]'>
            <div className="mb-4">
                <label htmlFor="name" className="block text-white font-medium mb-2">Full Name</label>
                <input type="text" id="name" name='name' value={user.name} onChange={handleInput} className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
            </div>
            <div className="mb-4">
                <label htmlFor="email" className="block text-white font-medium mb-2">Email</label>
                <input type="text" id="name" name='email' value={user.email} onChange={handleInput} className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
            </div>
            <div className="mb-4">
                <label htmlFor="Phone" className="block text-white font-medium mb-2">Phone</label>
                <input type="tel" id='phone' name='phone' value={user.phone} onChange={handleInput} className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
            </div>
            
            <div className="mb-4">
                <label htmlFor="Address" className="block text-white font-medium mb-2">Address</label>
                <textarea cols={3} type="text" id="Address" name='Address' value={user.Address} onChange={handleInput} className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
            </div>

            <div className="grid md:grid-cols-2 md:gap-6">
            <div className="relative z-0 w-full mb-5 group">
                    <label htmlFor="name" className="block text-white font-medium mb-2">Car Registration</label>
                    <input type="text" id="car_rego" name='car_rego' value={user.car_rego} onChange={handleInput} className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
                    
                </div>
            <div className="mb-4">
            <label htmlFor="name" className="block text-white font-medium mb-2">Car purpose</label>
                <select id="gender" name='car_purpose' value={user.car_purpose} onChange={handleInput}
                    className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required>
                    <option value="">Select purpose</option>
                    <option value="Taxi">Taxi</option>
                    <option value="Rideshare">Rideshare</option>
                    <option value="other">Other</option>
                </select>
            </div>
            </div>
            <div className="grid md:grid-cols-2 md:gap-6">
                <div className="relative z-0 w-full mb-5 group">
                    <label htmlFor="name" className="block text-white font-medium mb-2">Insurance Start Date</label>
                    <input type="date" id="insurance_s_d" name='insurance_s_d' value={user.insurance_s_d} onChange={handleInput}className="border border-gray-400 p-2 w-full rounded-lg text-black focus:outline-none focus:border-blue-400" required />
                    
                </div>
            </div>
            <div className='w-full'>
                <button type="submit" className="bg-yellow-500 text-white px-4 py-2 font-bold tracking-wider text-xl rounded-lg hover:bg-yellow-600 w-full" onClick={QuoteSubmit}>Submit</button>
            </div>

        </form>
        </div>
        </div>
        </div>
    </div>
  )
}

export default Quote;
